import React from "react"
import CreateAccountForm from "./CreateAccountForm/"
import Logo from "../../common/Logo"
import "./CreateAccount.css"

function CreateAccount() {
  return (
    <div className="createAccountBG">
      <div className="createAccountBox">
        <Logo />
        <h1>Create Account</h1>
        <p>Set up your business profile and business settings.</p>
        <h2>BUSINESS PROFILE</h2>
        <CreateAccountForm />
      </div>
    </div>
  )
}

export default CreateAccount
